module.exports = __webpack_public_path__ + "image/3.172a6a3.png";